import Switch from "react-switch";
import styled from "@emotion/styled";

export const SwitchWrapper = styled.div<{ size: "large" | "small" }>`
  align-items: center;
  display: flex;
  padding: 0.625rem 0rem;
  ${({ size }) =>
    size === "large" ? `padding: 0.625rem 0rem;` : `padding: 0px;`}
`;

export const StyledSwitch = styled(Switch)`
  &.size-large {
    &.toggle-true {
      .react-switch-handle {
        height: 1.625rem !important;
        width: 1.625rem !important;
        top: 0.3125rem !important;
        right: 1.8438rem !important;
      }
    }
    &.toggle-false {
      .react-switch-handle {
        height: 1.625rem !important;
        width: 1.625rem !important;
        top: 0.3125rem !important;
        left: 0.3125rem !important;
      }
    }
  }

  &.size-small {
    &.toggle-true {
      .react-switch-handle {
        height: 18px !important;
        width: 18px !important;
        top: 2px !important;
        right: 22px !important;
      }
    }
    &.toggle-false {
      .react-switch-handle {
        height: 18px !important;
        width: 18px !important;
        top: 2px !important;
        left: 2px !important;
      }
    }
  }
`;

export const Label = styled.span`
  font-family: "Poppins", sans-serif;
  color: grey;
  font-size: 0.875rem;
  font-weight: 500;
  margin-left: 0.625rem;

  @media (max-width: 768px) {
    font-size: 12px;
  }
`;

export const HelpingIcon = styled.span`
  margin-left: 0.3125rem;
  font-size: 1.125rem;
  color: grey;
`;
